import { FC, useMemo } from 'react';
import Image, { ImageProps } from 'next/image';
import { getOptimizedImageSources, isRemoteUrl } from 'src/utils/imageUtils';
interface OptimizeImageProps extends Omit<ImageProps, 'src' | 'loader'> {
  src: string;
  basePath?: string;
}
const OptimizeImage: FC<OptimizeImageProps> = ({
  src,
  alt,
  width,
  height,
  sizes,
  ...props
}) => {
  const shouldSkipOptimization = isRemoteUrl(src);
  const {
    avifSrcSet,
    webpSrcSet,
    fallbackSrc
  } = useMemo(() => shouldSkipOptimization ? {
    avifSrcSet: null,
    webpSrcSet: null,
    fallbackSrc: src
  } : getOptimizedImageSources(src, sizes), [shouldSkipOptimization, src, sizes]);
  if (shouldSkipOptimization) {
    return <Image loader={({
      src: _src
    }) => _src} src={src} alt={alt} width={width} height={height} loading='lazy' {...props} />;
  }
  return <picture style={{
    display: 'contents'
  }} data-sentry-element="picture" data-sentry-component="OptimizeImage" data-sentry-source-file="index.tsx">
      {avifSrcSet && <source srcSet={avifSrcSet} type='image/avif' sizes={sizes} />}
      {webpSrcSet && <source srcSet={webpSrcSet} type='image/webp' sizes={sizes} />}
      <Image unoptimized loader={({
      src: _src
    }) => _src} src={fallbackSrc} alt={alt} width={width} height={height} loading='lazy' {...props} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </picture>;
};
export default OptimizeImage;